export default "__VITE_ASSET__5Px$snOh__"